import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import uuidv4 from "uuid";

const Chip = ({ id, name, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const forTooltipId = `filter-icon-${id}`;
  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  return (
    <div key={uuid} className="chip">
      <span className="text"> {`${name} `}</span>
      <button onClick={() => onClick(id)} type="button" className="as-icon" aria-label="Close">
        <i id={forTooltipId} className="icono-remove" />
      </button>
      <Tooltip placement="top" isOpen={isOpen} target={forTooltipId} toggle={toggle}>
        Eliminar filtro
      </Tooltip>
    </div>
  );
};

Chip.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

Chip.defaultProps = {
  onClick: () => {}
};

export default Chip;
